<template>
    <div>
        <div class="tab-card">

            <div class="card-body">
                <ul class="nav nav-pills mb-0" id="pills-tab" style="justify-content:center;background-color: unset;">
                    <li :key="tab.name" class="nav-item" v-for="tab in tabs">
                        <a :class="{ 'btn-tab-selected-func': tabSelected == tab.name }"
                           @click="showFuctionalities(tab)"
                           class="btn px-4 float-right func-not-selected"
                           data-toggle="pill"
                        >{{ tab.name }}</a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: 'TabModule',
        props: {
            tabs: Array,
            selectedTab: Object
        },
        data() {
            return {
                tabSelected: ''
            };
        },
        methods: {
            showFuctionalities(tab) {
                this.tabSelected = this.selectedTab ? this.selectedTab.name : this.tabSelected;
                this.tabSelected = tab ? tab.name : this.tabSelected;
                this.$emit('method', tab.item, tab.existItems);
            }
        },
        watch: {
            tabs() {
                this.tabSelected = this.selectedTab.name;
                this.$emit('method', this.selectedTab.item);
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/share/tab.css';
</style>
